import { createSlice } from "@reduxjs/toolkit";
import { AgentTransactionDownload } from "../Apis/AgentTransactionDownload";

export const AgentTransactionDownloadSlice = createSlice({
  name: "agenttransactiondownload",
  initialState: {
    agenttransactiondownload: null,
    authenticatingagenttransactiondownload: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.agenttransactiondownload = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingagenttransactiondownload = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(AgentTransactionDownload.fulfilled, (state, action) => {
      state.agenttransactiondownload = action.payload;
      state.authenticated = false;
      state.authenticatingagenttransactiondownload = false;
      return state;
    });
    builder.addCase(AgentTransactionDownload.pending, (state, action) => {
      state.authenticatingagenttransactiondownload = true;
      state.authenticated = true;
    });
    builder.addCase(AgentTransactionDownload.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingagenttransactiondownload = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = AgentTransactionDownloadSlice.actions;

export const AgentTransactionDownloadSelector = (state) =>
  state.agenttransactiondownload;
